export function getLabelText(r: Element): string {
  if (!(r instanceof HTMLElement)) return "";
  let t: string | undefined | null = r.innerText.trim();
  if (t.length === 0) {
    t = r.textContent?.trim();
    if (t == null || t.length === 0) {
      t = r.getAttribute("aria-label");
      if (t == null || t.length === 0) {
        t = r.getAttribute("title");
      }
    }
  }
  return t ?? "";
}
